import React from "react";
import {
    ChPlusCircleIcon,
    ChCheckIcon,
    ChAlertIcon,
    ChClockIcon,
    ChTrashIcon,
} from "../Icons/ch-analytics-icons";

export const TIMEFRAME_OPTIONS = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "This Week", value: "thisWeek" },
    { label: "Last Week", value: "lastWeek" },
    { label: "This Month", value: "thisMonth" },
    { label: "Last Month", value: "lastMonth" },
];

export const METRIC_CONFIG = {
    created: {
        label: "Created Orders",
        color: "#2563EB",
        paleBg: "#EFF4FF",
        icon: <ChPlusCircleIcon />,
        stats: (s) => [
            { value: s.totalCount, label: "Total orders" },
            { value: s.totalDelivered, label: "Delivered" },
            { value: s.totalFailed, label: "Failed" },
            { value: s.totalIncomplete, label: "Incomplete" },
        ],
        columns: [
            { key: "orderNumber", header: "Order #", type: "orderlink" },
            { key: "customerName", header: "Customer", type: "text" },
            { key: "customerFormattedAddress", header: "Zone", type: "text" },
            { key: "placementTime", header: "Placed at", type: "datetime" },
            { key: "promisedDeliveryTime", header: "Promised by", type: "datetime" },
            { key: "driverName", header: "Assigned to", type: "text" },
            { key: "orderStatus", header: "Status", type: "badge" },
        ],
    },

    delivered: {
        label: "Delivered Orders",
        color: "#1B9970",
        paleBg: "#EAF7F2",
        icon: <ChCheckIcon />,
        stats: (s) => [
            { value: s.totalCount, label: "Total delivered" },
            { value: s.deliveredByDriver, label: "Via driver" },
            { value: s.deliveredByDispatcher, label: "By dispatcher" },
            { value: `${s.ontimePercentage}%`, label: "% on-time" },
        ],
        columns: [
            { key: "orderNumber", header: "Order #", type: "orderlink" },
            { key: "customerName", header: "Customer", type: "text" },
            { key: "placementTime", header: "Placed at", type: "datetime" },
            { key: "deliveryTime", header: "Delivered at", type: "datetime" },
            { key: "driverName", header: "Driver", type: "text" },
            { key: "completedBy", header: "Completed by", type: "badge" },
            { key: "deliveryDeltaMinutes", header: "Delivery Timing", type: "ontime" },
        ],
    },

    failed: {
        label: "Failed Orders",
        color: "#D94040",
        paleBg: "#FEF0F0",
        icon: <ChAlertIcon />,
        stats: (s) => [
            { value: s.totalCount, label: "Total failed" },
            { value: `${s.failRate ?? 0}%`, label: "Fail rate" },
        ],
        columns: [
            { key: "orderNumber", header: "Order #", type: "orderlink" },
            { key: "customerName", header: "Customer", type: "text" },
            { key: "placementTime", header: "Placed at", type: "datetime" },
            { key: "assignedTime", header: "Assigned at", type: "datetime" },
            { key: "driverName", header: "Driver", type: "text" },
            { key: "orderStatus", header: "Stage", type: "badge" },
            { key: "failedDeliveryTime", header: "Failed at", type: "datetime" },
        ],
    },

    incomplete: {
        label: "Incomplete Orders",
        color: "#E07020",
        paleBg: "#FEF3EB",
        icon: <ChClockIcon />,
        stats: (s) => [
            { value: s.totalCount, label: "Unassigned" },
            { value: `${s.avgWaitingMinutes ?? 0} min`, label: "Avg. wait" },
            { value: s.criticalCount, label: "Critical (>3h)" },
        ],
        columns: [
            { key: "orderNumber", header: "Order #", type: "orderlink" },
            { key: "customerName", header: "Customer", type: "text" },
            { key: "customerFormattedAddress", header: "Zone", type: "text" },
            { key: "placementTime", header: "Placed at", type: "datetime" },
            { key: "promisedDeliveryTime", header: "Promised by", type: "datetime" },
            { key: "waitingMinutes", header: "Waiting", type: "waiting" },
            { key: "orderStatus", header: "Status", type: "badge" },
        ],
    },

    deleted: {
        label: "Deleted Orders",
        color: "#6B7A8D",
        paleBg: "#F0F2F5",
        icon: <ChTrashIcon />,
        stats: (s) => [
            { value: s.totalCount, label: "Deleted" },
            { value: `${s.deletionRate ?? 0}%`, label: "Deletion rate" },
        ],
        columns: [
            { key: "orderNumber", header: "Order #", type: "orderlink" },
            { key: "customerName", header: "Customer", type: "text" },
            { key: "placementTime", header: "Placed at", type: "datetime" },
            { key: "deletedAt", header: "Deleted at", type: "datetime" },
            { key: "deletedBy", header: "Deleted by", type: "text" },
            { key: "deletedByRole", header: "Role", type: "badge" },
            { key: "orderStatus", header: "Status", type: "badge" },
        ],
    },
};
